<script setup lang="ts">
import { reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { ApiError } from "../api/client";
import { useAuthStore } from "../stores/auth";

const auth = useAuthStore();
const router = useRouter();
const route = useRoute();
const form = reactive({ username: "admin", password: "" });

async function submit(): Promise<void> {
  try {
    await auth.login(form.username, form.password);
    await router.replace(typeof route.query.redirect === "string" ? route.query.redirect : auth.homePath);
  } catch (error) {
    ElMessage.error(error instanceof ApiError ? error.message : "登录失败");
  }
}
</script>

<template>
  <div class="login-page">
    <section class="login-hero">
      <div class="hero-grid" />
      <div class="hero-content">
        <div class="hero-brand"><img src="/brand/edianlian-logo.png" alt="e电联" /><strong>云端电表平台</strong></div>
        <h1>每一相数据，<br />都清晰可见。</h1>
      </div>
    </section>
    <section class="login-panel">
      <div class="login-box">
        <span class="welcome">欢迎回来</span>
        <h2>登录管理平台</h2>
        <el-form label-position="top" @submit.prevent="submit">
          <el-form-item label="账号">
            <el-input v-model="form.username" size="large" autocomplete="username" placeholder="请输入账号" />
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="form.password" size="large" type="password" show-password autocomplete="current-password" placeholder="请输入密码" @keyup.enter="submit" />
          </el-form-item>
          <el-button type="primary" size="large" :loading="auth.loading" class="login-button" @click="submit">登录平台</el-button>
        </el-form>
      </div>
      <footer>e电联 · 云端电表平台</footer>
    </section>
  </div>
</template>

<style scoped>
.login-page { display: grid; min-height: 100vh; grid-template-columns: 58% 42%; background: #fff; }
.login-hero { position: relative; overflow: hidden; color: white; background: radial-gradient(circle at 72% 20%, rgba(44,110,230,.34), transparent 25%), linear-gradient(145deg,#111f38,#07101e 76%); }
.hero-grid { position: absolute; inset: 0; opacity: .18; background-image: linear-gradient(rgba(103,139,195,.15) 1px, transparent 1px),linear-gradient(90deg,rgba(103,139,195,.15) 1px,transparent 1px); background-size: 44px 44px; transform: perspective(700px) rotateX(55deg) scale(1.4) translateY(28%); }
.hero-content { position: relative; z-index: 2; display: flex; flex-direction: column; justify-content: center; width: 70%; height: 100%; margin: auto; }
.hero-brand { position: absolute; top: 32px; left: 0; display: flex; align-items: center; gap: 16px; }
.hero-brand img { width: 118px; height: 56px; object-fit: contain; }
.hero-brand strong { padding-left: 16px; border-left: 1px solid rgba(255,255,255,.18); font-size: 18px; letter-spacing: .05em; }
h1 { margin: 0; font-size: 52px; line-height: 1.16; letter-spacing: -.04em; }
.login-panel { display:flex; position:relative; align-items:center; justify-content:center; background:#fff; }
.login-box { width: 390px; }.welcome{color:#3478f6;font-size:12px;font-weight:700;letter-spacing:.14em}.login-box h2{margin:10px 0 8px;font-size:31px;letter-spacing:-.03em}.login-box>p{margin:0 0 34px;color:#8a94a6;font-size:14px}
.login-button{width:100%;margin-top:8px;height:47px}
footer{position:absolute;bottom:28px;color:#a3abba;font-size:11px}
</style>
